import React, { Fragment } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { isEmpty, dateFormation, convertTypeString, convertClass } from '../../../common/cores';


const CasinoHistory = (props) => {

    

    const { history, page, index } = props
  
    console.log("casinoHistory:", history)
    return (
        <Fragment key={index}>
            <tr key={index}>
                <td className="bet_history_td" >{isNaN(page.curPage) ? 0 : (page.curPage - 1) * 10 + index + 1}</td>
                {/* <td data-v-9dbb6d4c className=""> {history._id} </td> */}
                <td data-v-9dbb6d4c className="bet_history_td">{isEmpty(history) ? '' : dateFormation(history.created_date, 1)}</td>
                {/* <td data-v-9dbb6d4c className="">{isEmpty(history.amount) ? '' : Number(history.amount).toLocaleString()}</td> */}
                <td data-v-9dbb6d4c className="bet_history_td">{isEmpty(history.balance.bet) ? '' : Number(Math.abs(history.balance.bet)).toLocaleString()}</td>
                <td data-v-9dbb6d4c className="bet_history_td">{isEmpty(history.balance.win) ? '' : Number(history.balance.win).toLocaleString()}</td>
                <td data-v-9dbb6d4c className = {`bet_history_td ${convertClass(history.type)}`}>{convertTypeString(history.type)}</td>
            </tr>
        </Fragment>
    )
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(CasinoHistory);


// WEBPACK FOOTER //
// ./src/components/account/hisotries/CasinoHistory.js